import { createAction, props } from '@ngrx/store';
import { IShsEquipmentData } from '../models/installedbase.models';

export const INIT_MY_INSTALLED_BASE = '[My Installed Base] Init My Installed Base';
export const MY_INSTALLED_BASE_LOAD_CONTRACTS = '[My Installed Base] Load Contracts';
export const MY_INSTALLED_BASE_LOAD_CONTRACTS_SUCCESS = '[My Installed Base] Load Contracts SUCCESS';
export const MY_INSTALLED_BASE_LOAD_CONTRACTS_FAILURE = '[My Installed Base] Load Contracts FAILURE';
export const MY_INSTALLED_BASE_LOAD_EQUIPMENTS = '[My Installed Base] Load Equipments';
export const MY_INSTALLED_BASE_LOAD_EQUIPMENTS_SUCCESS = '[My Installed Base] Load Equipments SUCCESS';
export const MY_INSTALLED_BASE_LOAD_EQUIPMENTS_FAILURE = '[My Installed Base] Load Equipments FAILURE';

export const initMyInstalledBase = createAction(
  INIT_MY_INSTALLED_BASE,
);

export const loadMyInstalledBaseEquipments = createAction(
  MY_INSTALLED_BASE_LOAD_EQUIPMENTS,
);

export const loadMyInstalledBaseEquipmentsSuccess = createAction(
  MY_INSTALLED_BASE_LOAD_EQUIPMENTS_SUCCESS,
  props<{selectableEquipments: IShsEquipmentData[], otherEquipments: IShsEquipmentData[]}>(),
);

export const loadMyInstalledBaseEquipmentsFailure = createAction(
  MY_INSTALLED_BASE_LOAD_EQUIPMENTS_FAILURE,
  props<{resError: string}>(),
);

export const loadMyInstalledBaseContracts = createAction(
  MY_INSTALLED_BASE_LOAD_CONTRACTS,
);

export const loadMyInstalledBaseContractsSuccess = createAction(
  MY_INSTALLED_BASE_LOAD_CONTRACTS_SUCCESS,
  props<{needsAttentionContracts: IShsEquipmentData[], underContractContracts: IShsEquipmentData[]}>(),
);

export const loadMyInstalledBaseContractsFailure = createAction(
  MY_INSTALLED_BASE_LOAD_CONTRACTS_FAILURE,
  props<{resError: string}>(),
);
